module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component.css
// module id = ./src/app/kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component.css
// module chunks = main